import React, { useState, useEffect } from 'react';
import { Swiper } from 'swiper/react';
import Icon from '@atoms/Icon/Icon';
import Button from '@atoms/Button/Button';
import { IoMdArrowRoundForward } from 'react-icons/io';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { Box } from '@material-ui/core';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './CardSlider.scss';

CardSlider.defaultProps = {
    size: '2', // 3
};

function CardSlider(props) {
    const [swiperObject, setSwiperObject] = useState(null);

    let mod_class = ['CardSlider'];
    mod_class = mod_class.join(' ');

    let myTimeout;

    const sliderOption = {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            580: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },
        ...(props.sliderOption || {}),
    };

    useEffect(() => {
        myTimeout = setTimeout(() => {
            // Update swiper height
            if (swiperObject && swiperObject.visibleSlides) {
                swiperObject.updateAutoHeight();
                swiperObject.update();
            }
        }, 1000);

        return () => {
            clearTimeout(myTimeout);
        };
    }, [swiperObject]);

    if (props.hasNavigation && !props.sliderName) {
        return <></>;
    }

    const prevClass = `${props.sliderName}_CardSlider--navigation--prev`;
    const nextClass = `${props.sliderName}_CardSlider--navigation--next`;

    return (
        <div className={mod_class}>
            {props.hasNavigation && (
                <div className="CardSlider--navigation">
                    <Box sx={{ mr: 1 }}>
                        <Button
                            label={
                                <Icon
                                    icon={<IoMdArrowRoundBack />}
                                    size="xs"
                                    theme="white"
                                />
                            }
                            theme="pink-gradient"
                            size="s"
                            variant="circle"
                            className={prevClass}
                        />
                    </Box>
                    <Button
                        label={
                            <Icon
                                icon={<IoMdArrowRoundForward />}
                                size="xs"
                                theme="white"
                            />
                        }
                        theme="pink-gradient"
                        size="s"
                        variant="circle"
                        className={nextClass}
                    />
                </div>
            )}
            <Swiper
                pagination={props.navClass ? {
                    el: '.' + props.navClass,
                    clickable: false,
                    renderBullet: (index, className) => {
                        return (
                            '<span class="' +
                            className +
                            '">' +
                            (index + 1) +
                            '</span>'
                        );
                    },
                } : undefined}
                navigation={props.navClass ? {
                    nextEl: `.${nextClass}`,
                    prevEl: `.${prevClass}`,
                } : undefined}
                modules={props.navClass ? [Navigation, Pagination] : []}
                onSlideChange={(e) => { props?.onSlideChange?.(e) }}
                onSwiper={(swiper) => {
                    setSwiperObject(swiper);
                    props?.onSwiper?.(swiper)
                }}
                {...sliderOption}
            >
                {props.children}
            </Swiper>
        </div>
    );
}

export default CardSlider;
